export default __webpack_public_path__ + "static/media/store.2b5ae666.svg";